module.exports = __webpack_public_path__ + "static/media/renDGB.b92fb066.svg";